<template>
    <div class="nav"> 
        <div class="ak-nav-logo">
          <img src="../../assets/images/logo1.png" style="display:inline-block vertical-align: middle; height: 24px; padding-left: 30px;" />
        </div>
        <div class="ak-nav-logo1">
            Welcome to Certified Akuvox Partner Program !
        </div>
       
        <div class="ak-nav-content-data" @click="logout">
            Log out
            <img src="../../assets/images/logout_icon.png" style="vertical-align: middle;" />
        </div> 

        <div v-popover:popover1 class="ak-nav-content-data" style="text-align:left; padding-right:20px; width:auto;">
		{{ fullName }} 
        </div>
        <el-popover ref="popover1" width="270" trigger="click">
        <div class="personalData">
        <ul class="Data">
          <li>
            <label>Name:</label>
            {{ fullName }}
          </li>
          <li>
            <label>Email:</label>
            {{ userData.Email }}
          </li>
        </ul>
        <ul class="modify">
          <li @click="openName">Modify Name</li>
          <li @click="openPw">Modify Password</li>
        </ul>
      </div>
    </el-popover>
        <NameBox :firstName="userData.FirstName" :lastName="userData.LastName" :close="closeName" @update="getUserInfo()" v-if="alertName"></NameBox>
        <Password :close="closePw" v-if="alertPw"></Password>
    </div>
</template>

<script>
import NameBox from "./NameBox.vue";
import Password from "./PasswordBox.vue";
export default {
    components: {
        NameBox,
        Password
    },
    data() {
        return {
            userData:{},
            alertPw: false,
            alertName: false,
            fullName:""
        };
    },    
    mounted () {
        this.getUserInfo();
    },
    methods: {
        logout () {
            localStorage.removeItem("producttoken");
            // console.log(producttoken);
            this.$router.push("/login");
        },
        closeName() {
            this.alertName = false;
        },
        openName() {
            this.alertName = true;
        },
        closePw() {
            this.alertPw = false;
        },
        openPw() {
            this.alertPw = true;
        },
        getUserInfo () {
            this.$http.get("getAccountInfo",{},(data)=>{
                this.userData = data.data;
                this.fullName = this.userData.FirstName + " " + this.userData.LastName;
            });
        }
    }
};
</script>

<style lang="less" scoped>
    .nav{
        background-color: #0083fa;
        height: 100%;
        .ak-nav-content-line{
			display: inline-block;
			margin: 0 10px;
			background-color: rgba(0, 0, 0, 0.13);
			box-shadow: 1px 0 rgba(255, 255, 255, 0.22);
			width: 2px;
			height: 40px;
			position: relative;
			top: 10px;
        }
        .ak-nav-logo{
            display: inline-block;
			cursor: pointer;
            width: 100px;
            height: 50%;
			color: white;
			text-align: left;
            line-height: 74px;
            float: left;
            font-size: 30px;
            
        }
        .ak-nav-logo1{
            display: inline-block;
			cursor: pointer;
            
			color: white;
			text-align: left;
            line-height: 74px;
            
            margin-left:155px;
      
            font-size: 18px;
            
        }
        .ak-nav-content-data{
            display: inline-block;
			cursor: pointer;
			width: 100px;
			color: white;
			text-align: left;
            line-height: 74px;
            float: right;
          
			p{
				line-height: 20px;
			}
        }
        .personalData {
  width: 100%;
  box-sizing: border-box;
  ul.modify {
    padding-top: 15px;
    width: calc(~"100% + 20px");
    list-style: none;
    margin-left: -10px;
    li {
      font-size: 0.9rem;
      line-height: 40px;
      height: 40px;
      color: gray;
      cursor: pointer;
      padding-left: 20px;
      font-weight: bold;
    }
    li:hover {
      background-color: rgb(60, 160, 220);
      color: white;
    }
  }
}
    }
</style>